import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { PORequestsDashboardPage, PORequestsDetailPage } from '../components'

export const PORequestsRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<PORequestsDashboardPage />} />
      <Route path="/:poRequestId" element={<PORequestsDetailPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}
